import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Select from 'react-select'
import { eggGradeOptions } from './constants'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'

const EggsPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    Grade: item.Grade,
    ContainerSize: item.ContainerSize,
  })

  const methods = useFormContext()
  const { setSelectReviewer, asterisk } = useFormUtils()

  useEffect(() => {
    if (item !== null) {
      const { Grade, ContainerSize } = item

      setPackaging({
        Grade,
        ContainerSize,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <Row>
      <Col xs={6}>
        <h6>Grade {asterisk}</h6>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={eggGradeOptions}
          defaultValue={{ label: packaging.Grade, value: packaging.Grade }}
          name="Grade"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Grade'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="Grade"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <FormGroup>
          <h6>Size {asterisk}</h6>
          <Input defaultValue={packaging.ContainerSize} disabled />
        </FormGroup>
      </Col>
    </Row>
  )
}

EggsPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default EggsPackageReview
